import React, { useRef } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';

function NextArrow({ onClick }) {
  return (
    <>
      <div className='rounded-[100px] text-black hover:text-white bg-white hover:bg-hoverprimary w-10 h-10 mr-4 transition-all flex items-center justify-center cursor-pointer' onClick={onClick}>
        <IoIosArrowForward className='mx-auto text-xl' />
      </div>
    </>
  )
}
function PrevArrow({ onClick }) {
  return (
    <>
      <div className='rounded-[100px] text-black hover:text-white bg-white hover:bg-hoverprimary w-10 h-10 mr-4 transition-all flex items-center justify-center cursor-pointer' onClick={onClick}>
        <IoIosArrowBack className='mx-auto text-xl' />
      </div>
    </>
  )
}
export default function Books() {

  const sliderRef = useRef(null);

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
  }
  return (
    <>
      <div className="overflow-hidden">
        <img src="/assets/shapeline.png" alt="shape-line-top" className="block h-auto w-full rotate-180 opacity-90" />
      </div>

      <div className='py-20 bg-[#FFF5F3] relative overflow-hidden'>
        {/* <img
          src="/assets/left-line.svg"
          className="absolute -left-6 -top-6 w-40 md:w-56 z-0 pointer-events-none select-none"
          alt="leftline"
        /> */}
        <div className='max-w-7xl mx-auto px-0 relative z-10'>
          <div className='w-full flex flex-row flex-nowrap items-start gap-8 justify-between'>
            <div className='max-w-[600px] min-w-[300px] flex-shrink-0'>
              <h2 className='text-6xl mb-4' style={{ fontFamily: 'Philosopher, sans-serif' }}> Ladila Ghanshyam<br></br><span className='text-primary'>Books</span> shelf</h2>
              <p>Ladila Ghanshyam  Daily Darshan offers serene and divine glimpses of Bhagwan Swaminarayan.</p>
              <div className='flex items-center mt-9'>
                <PrevArrow onClick={() => sliderRef.current.slickPrev()} />
                <NextArrow onClick={() => sliderRef.current.slickNext()} />
                <Link className='ml-6 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white shadow-md transition-all duration-200 hover:bg-hoverprimary hover:shadow-lg' to='/books'>
                  <span>View More</span>
                  <MdKeyboardDoubleArrowRight className='text-base' />
                </Link>
              </div>
            </div>
            <div className='min-w-[220px] mt-0 -m-24 flex'>
              <img src='./assets/books.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden w-2/3 h-auto' />
              <img src='./assets/books.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden w-2/3 h-auto' />
              <img src='./assets/books.png' alt='daily-darshan' className='mb-4 rounded-2xl overflow-hidden w-2/3 h-auto' />
            </div>
          </div>
        </div>
        <img
          src="/assets/left-line.svg"
          className="absolute -right-6 -bottom-6 w-40 md:w-56 z-0 pointer-events-none select-none"
          style={{ transform: 'scaleX(-1) scaleY(-1)' }}
          alt="leftline"
        />
      </div>

      <div className="overflow-hidden">
        <img src="/assets/shapeline.png" alt="shape-line-bottom" className="block h-auto w-full opacity-90" />
      </div>
    </>
  )
}